import { get, del, post, put } from '@api/request';
import { convertLegacySketch } from '@modules/sketch/pages/create/util/convertLegacySketch';
import { sketchDefaultData } from '@modules/sketch/pages/create/constants';

export const deleteSketch = async (
  { sketchService, appraisalService },
  authenticationToken,
  { payload, modifier },
) => {
  if (modifier && modifier.improvement) {
    resetAppraisalProperty({ appraisalService }, authenticationToken, {
      modifier,
    });
  }
  const url = `${sketchService}/sketchservice/sketch/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

const resetAppraisalProperty = async (
  { appraisalService },
  authenticationToken,
  { modifier },
) => {
  // let improvement = await get(authenticationToken, `${sketchService}/appraisal/improvement/${improvementData.improvement.improvementId}`);
  let improvementId = modifier.improvement.improvementId;
  let data = {
    sketchID: 0,
    lastUpdate: modifier.improvement.lastUpdate,
  };
  await updateSketchId({ appraisalService }, authenticationToken, {
    improvementId,
    data,
  });
  let detailId = null;
  for (let x = 0; x < modifier.improvementDetails.length; x++) {
    data = {
      sketchArea: 0,
      perimeter: 0,
      arcs: 0,
      nodes: 0,
      lastUpdate: modifier.improvementDetails[x].updateDt,
    };
    detailId = modifier.improvementDetails[x].pDetailID;
    await updateImprovementDetailSketchFields(
      { appraisalService },
      authenticationToken,
      {
        detailId,
        data,
      },
    );
  }
};

export const editSketch = async (
  { sketchService, appraisalService },
  authenticationToken,
  { payload, modifier },
) => {
  if (payload === undefined) {
    const body = {
      results: [
        JSON.parse(JSON.stringify(sketchDefaultData)),
      ],
    };
    return body;
  }
  const url = `${sketchService}/sketchservice/sketch/${payload}`;
  let body = undefined;
  if (payload && Number(payload)) {
    const data = await get(authenticationToken, url);
    body = data ? data.body : undefined;
  }
  const index =
    modifier && modifier.improvementIndex ? modifier.improvementIndex : 0;
  if (
    body === undefined &&
    modifier &&
    ((modifier.sketchImprovementData.data[index] &&
      modifier.sketchImprovementData.data[index].sketchStatus === 'legacy') ||
      (modifier.sketchImprovementData.data[index] &&
        !modifier.sketchImprovementData.data[index].sketchStatus))
  ) {
    let body = {
      results: [
        JSON.parse(JSON.stringify(sketchDefaultData)),
      ],
    };
    //
    let sketchNoteData = null;
    if (
      modifier.user &&
      (modifier.user.office === 'Travis' ||
        modifier.user.office === 'Cameron' ||
        modifier.user.office === 'True Prodigy') &&
      modifier.sketchImprovementData.data[index].temp_pID &&
      modifier.sketchImprovementData.data[index].temp_pYear
    ) {
      sketchNoteData = await fetchSketchNotes(
        { appraisalService },
        authenticationToken,
        {
          pid: modifier.sketchImprovementData.data[index].temp_pID,
          pYear: modifier.sketchImprovementData.data[index].temp_pYear,
        },
      );
    }
    let annotations = [];
    if (
      sketchNoteData &&
      sketchNoteData.results &&
      sketchNoteData.results.length > 0
    ) {
      annotations = sketchNoteData.results.filter(r => {
        return (
          r.pImprovementID ===
          modifier.sketchImprovementData.data[index].pImprovementID
        );
      });
    }
    let data = {
      sketchCommands: body.results[0].sketchCommands,
      modifier: {
        improvement: modifier.sketchImprovementData.data[index],
        improvementDetails:
          modifier.sketchImprovementData.data[index].improvementDetails,
        annotations: annotations,
      },
    };
    data = convertLegacySketch(data, {
      initialData: JSON.parse(JSON.stringify(data)),
    });
    body.results[0].sketchCommands = data.sketchCommands;
    body.results[0].sketchID = null;
    return body;
  }
  return body;
};

export const fetchSketchNotes = async (
  { appraisalService },
  authenticationToken,
  { pid, pYear },
) => {
  const url = `${appraisalService}/appraisal/pacssketchnotes/${pid}/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchConfig = async (
  { sketchService },
  authenticationToken,
) => {
  const url = `${sketchService}/sketchservice/config/sketchsearch`;
  let { body } = await get(authenticationToken, url);
  // console.log('search config');
  // console.log(body);
  // console.log(body);
  // const results = {
  //   results: [
  //     {
  //       description: 'Description',
  //       group: 1,
  //       grouping: 'Sketch Filters',
  //       id: 'description',
  //       operators: [ 'in' ],
  //       order: 1,
  //       type: 'string'
  //     },
  //     {
  //       description: 'Sketch ID',
  //       group: 1,
  //       grouping: 'Sketch Filters',
  //       id: 'sketchID',
  //       operators: [ '=' ],
  //       order: 2,
  //       type: 'numeric'
  //     },
  //     {
  //       description: 'Date Created',
  //       group: 1,
  //       grouping: 'Sketch Filters',
  //       id: 'createDt',
  //       operators: [ '=' ],
  //       order: 3,
  //       type: 'date'
  //     },
  //     {
  //       description: 'Date Updated',
  //       group: 1,
  //       grouping: 'Sketch Filters',
  //       id: 'updateDt',
  //       operators: [ '=' ],
  //       order: 4,
  //       type: 'date'
  //     }
  //   ]
  const results = {
    results: [
      {
        description: 'ID',
        group: 1,
        grouping: 'Basic Search',
        id: 'sketchID',
        operators: ['like'],
        order: 1,
        type: 'string',
      },
      {
        description: 'Description',
        group: 1,
        grouping: 'Basic Search',
        id: 'description',
        operators: ['like'],
        order: 2,
        type: 'string',
      },
      {
        description: 'Address',
        group: 1,
        grouping: 'Basic Search',
        id: 'address',
        operators: ['like'],
        order: 3,
        type: 'string',
      },
      {
        description: 'Tags',
        group: 1,
        grouping: 'Basic Search',
        id: 'tags',
        operators: ['like'],
        order: 4,
        type: 'tags',
      },
      {
        description: 'Date Created',
        group: 1,
        grouping: 'Basic Search',
        id: 'createDt',
        operators: ['=', '>', '>=', '<', '<='],
        order: 5,
        type: 'date',
      },
      {
        description: 'Date Updated',
        group: 1,
        grouping: 'Basic Search',
        id: 'updateDt',
        operators: ['=', '>', '>=', '<', '<='],
        order: 6,
        type: 'date',
      },
    ],
  };
  body = results;
  return body;
};

export const fetchSearchResultsConfig = async (
  { sketchService },
  authenticationToken,
) => {
  const url = `${sketchService}/sketchservice/config/sketchsearchresults`;
  const { body } = await get(authenticationToken, url);
  // console.log('results config');
  // console.log(body);
  // body = {
  //   results: [
  //     {
  //       displayName: 'Sketch ID',
  //       id: 'sketchID',
  //       needFormatting: false,
  //       type: 'numeric'
  //     },
  //     {
  //       displayName: 'Sketch Description',
  //       id: 'description',
  //       needFormatting: false,
  //       type: 'string'
  //     },
  //     {
  //       displayName: 'Date / Time',
  //       id: 'updateDt',
  //       needFormatting: false,
  //       type: 'date'
  //     },
  //     {
  //       displayName: 'User',
  //       id: 'createdBy',
  //       needFormatting: false,
  //       type: 'string'
  //     }
  //   ]
  // };
  return body;
};

export const fetchSketchSettings = async (
  { sketchService },
  authenticationToken,
) => {
  const url = `${sketchService}/sketchservice/sketch/settings`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const setSketchSettings = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/settings`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const saveSketch = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketches`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

// export const search = async ({sketchService}, authenticationToken) => {
//   const url = `${sketchService}/sketchservice/sketches`;
//   const { body } = await get(authenticationToken, url);
//   return body;
// };

export const updateAppraisalSketch = async (
  { sketchService, appraisalService },
  authenticationToken,
  { payload, modifier, table },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload.sketchID}`;
  const data1 = await put(authenticationToken, url, payload);
  let data = {
    sketchID: data1.body.results[0].sketchID,
    lastUpdate: modifier.improvement.lastUpdate,
  };
  let improvementId = modifier.improvement.improvementId;
  let sketchIdData = await updateSketchId({ appraisalService }, authenticationToken, {
    improvementId,
    data,
  });
  if(sketchIdData && sketchIdData.results && data1 && data1.body && data1.body.results) {
    data1.body.improvementResults = sketchIdData.results;
  }
  let detailId = null;
  for (let x = 0; x < table.length; x++) {
    data = {
      sketchArea: table[x].area,
      perimeter: table[x].perimeter,
      arcs: table[x].arcs,
      nodes: table[x].nodes,
      lastUpdate: modifier.improvementDetails[x].updateDt,
    };
    detailId = modifier.improvementDetails[x].pDetailID;
    await updateImprovementDetailSketchFields(
      { appraisalService },
      authenticationToken,
      {
        detailId,
        data,
      },
    );
  }
  return data1;
};

export const saveAppraisalSketch = async (
  { sketchService, appraisalService },
  authenticationToken,
  { payload, modifier, table },
) => {
  // console.log(payload);
  // console.log(modifier);
  // console.log(table);
  const url = `${sketchService}/sketchservice/sketches`;
  const data1 = await post(authenticationToken, url, payload);
  // console.log('sketch save data');
  // console.log(data1);
  let data = {
    sketchID: data1.body.results[0].sketchID,
    lastUpdate: modifier.improvement.lastUpdate,
  };
  let improvementId = modifier.improvement.improvementId;
  let sketchIdData = await updateSketchId({ appraisalService }, authenticationToken, {
    improvementId,
    data,
  });
  if(sketchIdData && sketchIdData.results && data1 && data1.body && data1.body.results) {
    data1.body.improvementResults = sketchIdData.results;
  }
  let detailId = null;
  for (let x = 0; x < table.length; x++) {
    data = {
      sketchArea: table[x].area,
      perimeter: table[x].perimeter,
      arcs: table[x].arcs,
      nodes: table[x].nodes,
      lastUpdate: modifier.improvementDetails[x].updateDt,
    };
    detailId = modifier.improvementDetails[x].pDetailID;
    await updateImprovementDetailSketchFields(
      { appraisalService },
      authenticationToken,
      {
        detailId,
        data,
      },
    );
  }
  return data1;
};

const updateSketchId = async (
  { appraisalService },
  authenticationToken,
  { improvementId, data },
) => {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/sketch`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

const updateImprovementDetailSketchFields = async (
  { appraisalService },
  authenticationToken,
  { detailId, data },
) => {
  if (data.perimeter) {
    data.sketchPerimeter = data.perimeter;
    data.perimeterSource = 'S';
  }
  const url = `${appraisalService}/appraisal/improvementdetail/${detailId}/sketch`;
  const { body } = await put(authenticationToken, url, data);
  return body;
};

export const search = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  // console.log('search payload');
  // console.log(payload);
  if (payload.tags) {
    payload.tags.operator = 'like';
    payload.tags.values = [payload.tags.value];
  }
  const url = `${sketchService}/sketchservice/sketch/search`;
  const { body } = await post(authenticationToken, url, payload);
  // const { body } = await get(authenticationToken, `${sketchService}/sketchservice/sketches`);
  // console.log(body);
  return body;
};

export const sketchQuery = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateSketch = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload.sketchID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export async function getImprovements(
  { appraisalService },
  authenticationToken,
  { costId, currentImprovement, improvementIndex },
) {
  const url = `${appraisalService}/appraisal/costapproach/${costId}/improvements`;
  let { body } = await get(authenticationToken, url);
  let index = improvementIndex > -1 ? improvementIndex : 0;
  if (improvementIndex === -1 && currentImprovement) {
    for (let x = 0; x < body.results.length; x++) {
      if (body.results[x].pImprovementID === currentImprovement) {
        index = x;
        break;
      }
    }
  }
  if (body) {
    let improvementId = body.results[index].pImprovementID;
    const data2 = await fetchPropertyImprovementDetails(
      { appraisalService },
      authenticationToken,
      { improvementId },
    );
    body.results[index].improvementDetails = data2 ? data2.results : [];
  } else {
    body = {
      results: [],
    };
  }
  return body;
}

const fetchPropertyImprovementDetails = async (
  { appraisalService },
  authenticationToken,
  { improvementId },
) => {
  const url = `${appraisalService}/appraisal/improvement/${improvementId}/improvementdetails`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const editComment = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketchcomment/${payload.commentID}`;
  const { body } = await put(authenticationToken, url, payload.body);
  return body;
};

export const postComment = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload.sketchID}/comments`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getComments = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload}/comments`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteComment = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketchcomment/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const postTag = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload.sketchID}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getTags = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload}/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteTag = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/tag/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};
